import { render } from "./ExtensionAuth.vue?vue&type=template&id=901d4f98&scoped=true"
import script from "./ExtensionAuth.vue?vue&type=script&lang=js"
export * from "./ExtensionAuth.vue?vue&type=script&lang=js"

import "./ExtensionAuth.vue?vue&type=style&index=0&id=901d4f98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-901d4f98"]])

export default __exports__